module.exports = __webpack_public_path__ + "img/pr-4.87605367.png";